module.exports = __webpack_public_path__ + "static/the-bully-pulpit-fb9acbb1f7208e786e44bd3365d5ac84.jpg";